<template>
<div id="fcr_beta_widget">
    <div class="app_container">
        <div class="header">
            <div class="title">
                <span class="letter">F</span>act <span class="letter">C</span>heck <span class="letter">R</span>eview
            </div>
        </div>
        <div class="summary">
            Each week, we review fact-checking outlets that Facebook uses for guidance. 
            <span class="more">
                <a href="https://www.realclearpolitics.com/fact_check_review/">Full Review &raquo;</a>
            </span>
        </div>
        <div class="charts">
            <fc-chart 
                title="Fact vs. Opinion Checks" 
                :data="chart_data_fact_vs_opinion" 
                ></fc-chart>
            <fc-chart 
                title="Media Sourcing Itself" 
                :data="chart_data_sourcing_media" 
                ></fc-chart>
            <fc-chart 
                title="Fact Checking Marketplace" 
                :data="chart_data_fact_checkers" 
                num-compare-with-top="true" 
                ></fc-chart>
        </div>

        <div v-if="!loadingFeatured && featured_fcs.length > 0" id="beta-featured-widget" >
            <div class="featured-heading">
                <h3>Featured Review Searches</h3>
            </div>
            <div class="featured-items">
                <template v-for="(item, index) in featured_fcs" >
                <div class="featured-item" :key="item.id" v-if="index < 2" >
                    <div class="featured-fc-heading" >
                        <a :href="factCheckUrl+'?featId='+item.id" v-text="item.title" ></a>
                    </div>
                </div>
                </template>
            </div>
        </div>

        <div class="view_more">
            <span class="more"><a href="https://www.realclearpolitics.com/fact_check_review/">View Full Review &raquo;</a></span>
        </div>
    </div>
</div>
</template>

<script>

const FcChart = () => import(/* webpackChunkName: "FactCheckFcChart" */ "./FcChart.vue");
import FactCheckMixin from './FactCheckMixin.js';

export default {
    name: 'home-beta-widget',
    components: {
        'fc-chart': FcChart,
    },
    mixins: [
        FactCheckMixin,
    ],
    data : function() {
        return {
            chart_data_fact_vs_opinion : { "fact_check_orgs" : [] },
            chart_data_sourcing_media : { "fact_check_orgs" : [] },
            chart_data_fact_checkers : { "fact_check_orgs" : [] },

            loadingFeatured: true,
            featured_json_loc: '/fact_check_review/feed/featured_fcs.jsonp',
            featured_fcs: [],
            factCheckUrl: 'https://www.realclearpolitics.com/fact_check_review/',
        };
    },
    created : function() {
        this.load_content();
    },
    methods : {

        plug_in_query_data : function(data) {

            // Clear existing data first
            this.chart_data_fact_checkers.fact_check_orgs = [];
            this.chart_data_sourcing_media.fact_check_orgs = [];
            this.chart_data_fact_vs_opinion.fact_check_orgs = [];

            for(var i = 0; i < data.fact_checking_marketplace.length; i++) {

                var fco = data.fact_checking_marketplace[i];
                var new_fco = {
                    name : fco.name,
                    result : fco.fact_checkers_count,
                    out_of : fco.fact_checkers_total,
                };

                this.chart_data_fact_checkers.fact_check_orgs.push(new_fco);
            }

            for(var i = 0; i < data.media_sourcing_itself.length; i++) {

                var fco = data.media_sourcing_itself[i];
                var new_fco = {
                    name : fco.name,
                    perc : Math.round(fco.percent),
                    result : fco.media_count,
                    out_of : fco.media_count_total,
                };

                this.chart_data_sourcing_media.fact_check_orgs.push(new_fco);
            }

            for(var i = 0; i < data.fact_vs_opinion.length; i++) {

                var fco = data.fact_vs_opinion[i];
                var new_fco = {
                    name : fco.name,
                    perc : Math.round(fco.percent),
                    result : fco.factual_claims,
                    out_of : fco.total_claims,
                };

                this.chart_data_fact_vs_opinion.fact_check_orgs.push(new_fco);
            }
        },

        cache_buster: function(){
            return Math.floor(Date.now() / 300000);
        },

        load_content : function() {

            var $this = this;

            $.ajax({
                method: 'get',
                dataType : 'jsonp',
                url: window.location.protocol+'//www.realclearpolitics.com/fact_check_review/json/live/recent_query_live.jsonp?nocache='+this.cache_buster(),
                jsonpCallback: "jsonCallback",
                success: function(res){

                    if( typeof res == 'object'){

                        $this.plug_in_query_data(res);

                    }else{
                        console.log("data not an object");
                    }

                },

                complete: function(){

                    $this.loadFeaturedFactChecks();

                },

            });
        },

        loadFeaturedFactChecks: function(){

            var $this = this;

            $.ajax({
                method: 'get',
                dataType : 'jsonp',
                url: window.location.protocol+'//www.realclearpolitics.com'+this.featured_json_loc+'?nocache='+this.cache_buster(),
                jsonpCallback: "jsonCallback",
                success: (res) => {

                    if(res){

                        console.log("ALPHAS FEATURED FCS", res);
                        $this.featured_fcs = this.getRandomFeaturedFactChecks(2, res);
                        $this.loadingFeatured = false;

                    }else{
                        console.log("data not an object");
                    }

                },

                error: function(err){
                    console.log("ALPHA FEATURED ERROR", err);
                },

            });

        },

    },
}
</script>

<style lang="scss">
@import "../../top/fact_check_review/beta_widget.css";
</style>